import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { useTranslate, required, NumberInput, minValue, maxValue, BooleanInput } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'

export const Credits = ({ hash_business_unit, isLoading, isFetching }) => {
  const translate = useTranslate()
  const { setValue } = useFormContext()
  const [creditsAvailableLoading, setCreditsAvailableLoading] = useState(true)

  useEffect(() => {
    if (!isLoading && !isFetching) {
      getCreditsByhash(hash_business_unit)
    }
  }, [hash_business_unit, isFetching, isLoading])

  const getCreditsByhash = async (hash) => {
    try {
      setCreditsAvailableLoading(true)
      const credits = await businessUnitServices.getCreditsByBusinessUnitHash(hash)
      if (credits) {
        const { credit, has_credit, limit_credit } = credits
        setValue('credit', credit)
        setValue('has_credit', has_credit)
        setValue('limit_credit', limit_credit)
      }
    } catch (error) {
    } finally {
      setCreditsAvailableLoading(false)
    }
  }

  const parseToTwoDecimals = (value) => {
    if (!value) return
    const floatValue = parseFloat(value)
    return floatValue.toFixed(2)
  }

  return (
    <>
      <Grid container spacing={3}>
        <EditInputsWrap label={translate('ra.field.available_credits')}>
          {creditsAvailableLoading ? (
            <Skeleton variant='rectangular' width={'100%'} height={40} />
          ) : (
            <NumberInput label='' source='credit' fullWidth disabled parse={parseToTwoDecimals} />
          )}
        </EditInputsWrap>
      </Grid>
      <Grid container spacing={3}>
        <EditInputsWrap label={translate('ra.field.credit_to_sum')} required>
          <NumberInput
            label=''
            source='credit_to_sum'
            fullWidth
            defaultValue={0}
            validate={[required(), minValue(-10000000), maxValue(10000000)]}
          />
        </EditInputsWrap>
        <EditInputsWrap label={translate('ra.field.limit_credit')}>
          {creditsAvailableLoading ? (
            <Skeleton variant='rectangular' width={'100%'} height={40} />
          ) : (
            <NumberInput
              label=''
              source='limit_credit'
              defaultValue={0}
              fullWidth
              validate={[minValue(0), maxValue(999999)]}
            />
          )}
        </EditInputsWrap>
        <EditInputsWrap label={translate('ra.field.has_credit')}>
          {creditsAvailableLoading ? (
            <Skeleton variant='rectangular' width={'100%'} height={40} />
          ) : (
            <BooleanInput label={translate('ra.field.has_credit')} source='has_credit' fullWidth />
          )}
        </EditInputsWrap>
      </Grid>
    </>
  )
}
